<template>
  <div
    class="small-image"
    @click="$emit('edit')"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div class="small-image__img">
      <Resource :src="currentUrl" :transform-resource="transformImage" />
    </div>
    <InfoText
      v-if="!disabled"
      :class="[
        'small-image__info',
        position === 'right' ? 'small-image__info--right' : 'small-image__info--left',
      ]"
      :text="text"
    />
  </div>
</template>
<script lang="ts" setup>
import { transformImage } from '~/utils/';
import InfoText from './info-text.vue';

interface SmallImageProps {
  url: string;
  hoverUrl?: string;
  position: 'left' | 'right';
  text: string;
  disabled?: boolean;
}

const props = defineProps<SmallImageProps>();

defineEmits(['edit']);

const isHovered = ref(false);

const currentUrl = computed(() => {
  return isHovered.value && props.hoverUrl ? props.hoverUrl : props.url;
});

const handleMouseEnter = () => {
  if (props.hoverUrl) {
    isHovered.value = true;
  }
};

const handleMouseLeave = () => {
  isHovered.value = false;
};
</script>
<style lang="scss" scoped>
.small-image {
  position: relative;
  width: 122px;
  height: 122px;

  &:hover {
    .small-image__info {
      &:deep(.text-info) {
        background-color: var(--x-black-3);
        .breath-light-container {
          background-color: var(--x-black-3);
        }
      }
      &:deep(.breath-light-container) {
        background-color: var(--x-black-3);
      }
    }
    .small-image__img {
      background-color: var(--x-purple-1);
      border: 1px dashed var(--x-purple-4);
      cursor: pointer;
    }
  }

  .small-image__info {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    white-space: nowrap;
  }

  .small-image__info--left {
    left: 10%;
    transform: translate(-100%, -50%);
  }

  .small-image__info--right {
    right: 8%;
    transform: translate(100%, -50%);
    flex-direction: row-reverse;
  }

  .small-image__img {
    width: auto;
    max-width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 50%;
    background-color: var(--x-back-3);
    border: 1px solid transparent;

    img {
      height: 100%;
      width: auto;
    }
  }
}
</style>
